import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import Terminos from "@/pages/Terminos";
import Privacidad from "@/pages/Privacidad";

function AppRouter() {
  const location = useLocation();
  // Google Auth callback comes back via URL fragment (#session_id=...)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/terminos" element={<Terminos />} />
      <Route path="/privacidad" element={<Privacidad />} />
      <Route path="/payment/success" element={<PaymentResult success />} />
      <Route path="/payment/cancel" element={<PaymentResult success={false} />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                border: "1px solid rgba(0, 240, 255, 0.25)",
                color: "#FFFFFF",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
